<template>
  <validation-observer
    ref="observer"
    v-slot="{ valid, invalid }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot
      :preSubmit="preSubmit"
      :reset="reset"
      :valid="valid"
      :invalid="invalid"
    ></slot>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
export default {
  name: 'BrbForm',
  components: {
    ValidationObserver
  },
  methods: {
    preSubmit(successCallback) {
      return this.$refs.observer.validate().then((proceed) => {
        if (successCallback && typeof successCallback === 'function') {
          if (proceed) successCallback()
        } else {
          return proceed
        }
      })
    },
    reset() {
      this.$refs.observer.reset()
    }
  }
}
</script>
